import { useState, useEffect } from "react";
import {
    Box,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Paper,
    Button,
    TextField,
    Card,
    Typography,
    CardContent,
} from "@mui/material";
import { toast } from "react-toastify";
import { get_inscriptions, get_parameters, save_inscription, set_parameters } from "./services";
import { useForm } from "react-hook-form";

import { SendAndArchiveOutlined } from "@mui/icons-material";
import { TextInput } from "./TextInput";

function display_row(title, value) {
    if (!value) return;
    return (
        <TableRow>
            <TableCell align="center">
                <Box fontWeight="fontWeightMedium">{title}</Box>
            </TableCell>
            <TableCell style={{ width: 100 }}>{value}</TableCell>
        </TableRow>
    );
}

export default function Dashboard() {
    const [inscriptions, set_inscriptions] = useState([]);
    const [parameters, set_local_parameters] = useState(null);
    const [max_nb_inscriptions, set_max_nb_inscriptions] = useState(0);
    const defaultFormValues = { nom: "", prenom: "", email: "", telephone: "" };

    async function update_parameters(stop_inscriptions, max_nb_inscriptions) {
        if (!parameters) {
            return;
        }
        try {
            set_max_nb_inscriptions(max_nb_inscriptions);
            await set_parameters({ id: parameters["id"], stop_inscriptions, max_nb_inscriptions });
            const { data: parameters_found } = await get_parameters();
            if (!parameters_found.length) {
                toast.error("Aucune parametre trouvé !");
            } else {
                set_local_parameters(parameters_found[0]);
                set_max_nb_inscriptions(parameters_found[0]["max_nb_inscriptions"]);
            }
        } catch (e) {
            console.log(e);
            toast.error("Erreur dans la mise à jour des paramètres");
        }
    }

    const { control, handleSubmit, reset } = useForm({
        defaultValues: defaultFormValues,
    });

    const onSubmit = async (values) => {
        try {
            // if (values.email && values.email.length > 0) {
            //     const { data: inscriptions_with_same_email } = await get_inscriptions({ email: values.email });
            //     if (inscriptions_with_same_email?.length > 0) {
            //         toast.error("Cette adresse mail est déjà utilisée pour une inscription");
            //         return;
            //     }
            // }

            const res = await save_inscription(values);
            if (res.status < 200 || res.status >= 400) {
                throw new Error("Wrong return code");
            }
            reset(defaultFormValues);

            toast.success("Inscription enregistrée !");
        } catch (e) {
            console.log(e);
            toast.error("Erreur dans l'enregistrement de l'inscription");
        }
    };

    useEffect(() => {
        async function get_datas() {
            try {
                const { data: parameters_found } = await get_parameters();
                if (!parameters_found.length) {
                    toast.error("Aucune parametre trouvé !");
                } else {
                    set_local_parameters(parameters_found[0]);
                    set_max_nb_inscriptions(parameters_found[0]["max_nb_inscriptions"]);
                }
                const { data: inscriptions_found } = await get_inscriptions();
                set_inscriptions(inscriptions_found);
            } catch (e) {
                console.log(e);
                toast.error("Erreur");
            }
        }
        get_datas();
    }, []);

    return (
        <Box sx={{ mx: 1 }}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                    <Typography variant="h5">Informations</Typography>
                </Grid>
                <Grid item xs={12} md={12}>
                    <Card>
                        <CardContent>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: "100%" }} aria-label="simple table">
                                    {parameters && (
                                        <TableBody>
                                            {display_row("Inscriptions", `${inscriptions?.length} / ${parameters["max_nb_inscriptions"]}`)}
                                            {display_row(
                                                "Inscriptions validées",
                                                `${inscriptions?.filter((item) => item.date_validation).length} / ${inscriptions?.length}`,
                                            )}
                                            {display_row(
                                                "Inscriptions ouvertes",
                                                !parameters["stop_inscriptions"] ? (
                                                    <Button
                                                        variant="contained"
                                                        color="success"
                                                        onClick={() =>
                                                            update_parameters(!parameters["stop_inscriptions"], parameters["max_nb_inscriptions"])
                                                        }
                                                    >
                                                        Oui
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        variant="contained"
                                                        color="error"
                                                        onClick={() =>
                                                            update_parameters(!parameters["stop_inscriptions"], parameters["max_nb_inscriptions"])
                                                        }
                                                    >
                                                        Non
                                                    </Button>
                                                ),
                                            )}
                                            {display_row(
                                                "Maximum d'insciptions",

                                                <TextField
                                                    type="number"
                                                    label="Valeur"
                                                    value={max_nb_inscriptions}
                                                    onChange={(e) => {
                                                        const next = e.target.value === "" ? 0 : Number(e.target.value);
                                                        update_parameters(parameters["stop_inscriptions"], next);
                                                    }}
                                                    // Optionnel : n'appeler l'API qu'à la validation (blur / Enter)
                                                    // onBlur={(e) => update_value(Number(e.target.value))}
                                                    inputProps={{ step: 1 }}
                                                />,
                                            )}
                                        </TableBody>
                                    )}
                                </Table>
                            </TableContainer>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} md={12}>
                    <Typography variant="h5">Ajouter une inscription</Typography>
                </Grid>
                <Grid item xs={12} md={12}>
                    <Card>
                        <CardContent>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <Grid container spacing={2} direction="column" alignItems="center" justify="center">
                                    <Grid item xs={12} md={12}>
                                        <TextInput required name="nom" fullWidth control={control} label="Nom" />
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <TextInput required name="prenom" fullWidth control={control} label="Prénom" />
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <TextInput name="email" fullWidth control={control} label="Email" />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={5} paddingTop={5} direction="column" alignItems="center" justifyContent="center">
                                    <Grid item xs={12}>
                                        <Button variant="contained" type="submit" endIcon={<SendAndArchiveOutlined />}>
                                            Enregistrer
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
}
